
// all slider
window.SplideSliderFunction = function () {
  document.querySelectorAll('.splide:not(.product-loop-slider)').forEach((element) => {
    const perPage = parseInt(element.dataset.perPage) || 1;
    const gap = element.dataset.gap || '24px';
    const drag = element.dataset.drag === 'true';
    const arrows = element.dataset.arrows === 'true';
    const direction = element.dataset.direction;
    const height = element.dataset.height;
    const autoplay = element.dataset.autoplay === 'true';
    const autoplayintervel = parseInt(element.dataset.autoplayintervel);
    const type = element.dataset.type;
    const paginatione = element.dataset.pagination == 'true';
    
    // Banner check
    const isBanner = element.dataset.banner === 'yes';
    const mobileshow = isBanner ? 1 : 2;

   
    const splide = new Splide(element, {
      type: type,
      perPage: perPage,
      arrows: arrows,
      pagination: paginatione,
      drag: drag,
      autoplay: autoplay,
      gap: gap,
      interval: autoplayintervel || 3000,
      breakpoints: {
        989: {
          pagination: paginatione,
          drag: true,
          perPage: mobileshow,
          gap: "20px"
        },
        767: {
          perPage: mobileshow,
          arrows: arrows,
          pagination: paginatione,
        },
        575: {
          perPage: 1,
          arrows: arrows,
          pagination: paginatione
        }
      }
    });



splide.mount();
    
    
  });
  
};

SplideSliderFunction();



// index faq
document.addEventListener("DOMContentLoaded", function (){

     document.querySelectorAll(".question").forEach(function (item){
        item.addEventListener("click", function (){
         this.parentElement.classList.toggle("active");

          // hide show div
         const nextdiv = this.nextElementSibling;
          if (window.getComputedStyle(nextdiv).display == "none"){
               nextdiv.style.display = "block";

          }else{
               nextdiv.style.display = "none";
          }


         // sibling process
         const topparent = this.parentElement.parentElement.children;
        
         for( let i=0; i < topparent.length; i++){  
          const siblingcount = topparent[i]; 
              console.log(siblingcount);
            if(siblingcount != this.parentElement){
               siblingcount.classList.remove("active");
               const dataText = siblingcount.querySelector(".answer");
                dataText.style.display = "none";
            }
         }           
        });

    });
});



// banner scroll
const scrollBtn = document.querySelector(".scroll-down-btn");

if (scrollBtn) {
  scrollBtn.addEventListener("click", function () {
    const nextSection = document.querySelector("#next-section");
    if (nextSection) {
      nextSection.scrollIntoView({ behavior: "smooth" });
    }
  });
}






 // Handle .vdo-btn-click click
 document.querySelectorAll('.vdo-btn-click').forEach(function(btn) {
  btn.addEventListener('click', function () {

    const blogWrapper = btn.closest('.blog-vdo-wrap');

    if (!blogWrapper) return;

    // Hide thumbnail
    const thumbWrap = blogWrapper.querySelector('.thumb-btn-wrap');
    if (thumbWrap) thumbWrap.style.display = 'none';

    // Get the video inside the SAME block
    const video = blogWrapper.querySelector('video');

    if (video) {
      video.load();   // ensures loading
      video.play();   // start video
    }
  });
});




// Coupen code click
// Coupon code click
const couponElement = document.getElementById("couponCode");

if (couponElement) {
  couponElement.addEventListener("click", function () {
    const code = this.innerText.trim();
    const element = this;

    navigator.clipboard.writeText(code).then(function () {
      const originalText = element.innerText;
      element.innerText = "Copied!";
      element.style.color = "green";

      setTimeout(() => {
        element.innerText = originalText;
        element.style.color = "";
      }, 2000);
    });
  });
}





// certificate sheet API script
const verifyBtn = document.getElementById("verifyBtn");

if (verifyBtn) {
  verifyBtn.addEventListener("click", async function () {

  const inputNum = document.getElementById("certNumber").value.trim();
  const checkbox = document.getElementById("certCheck");

  
 // Validate input field empty
  if (!inputNum) {
    let inputError = document.querySelector(".input-error");

    if (!inputError) {
      inputError.textContent = "Please enter the certificate number.";
    }
    
    inputError.textContent = "Please enter the certificate number.";

    setTimeout(() => {
        inputError.textContent = "";
    }, 2000);
  
    return;
  }


  // Validate checkbox
      // if (checkbox && !checkbox.checked) {
      //   let errorDiv = document.querySelector(".checkbox-error");

      //   // If error div doesn't exist, create it
      //   if (!errorDiv) {
      //     errorDiv = document.createElement("div");
      //     errorDiv.className = "checkbox-error";
      //     checkbox.parentNode.appendChild(errorDiv);
      //   }

      //   // Show error message
      //   errorDiv.textContent = "Please accept the terms before verifying the certificate.";

      //   // Remove after 5 seconds
      //   setTimeout(() => {
      //     if (errorDiv) {
      //       errorDiv.remove();
      //     }
      //   }, 2000);

      //   return;
      // }


 const url =
  "https://opensheet.elk.sh/1MZgjf2jzIdgjhK0y5Z1E-WDoGXjJkO6Jfjiq-3W2xR8/Total_Sales_Report";

const res = await fetch(url);
const data = await res.json();

// Find matching row
const match = data.find(row => row["Certificate No."] == inputNum);

if (!match) {
  const output = document.getElementById("certificateOutput");
  output.innerHTML = "<p style='color:red;'>Certificate not found</p>";

  setTimeout(() => {
    output.innerHTML = "";
  }, 2000); // hides after 2 seconds

  return;
}

// Build certificate UI
document.getElementById("certificateOutput").innerHTML = `
  <div class="certificate-box-wrap">
    <div class="info-wrapper certificate-box">
    <h2>Certificate</h2>
    <div class="item-wrap">
     <div class="left-wrapper">
    <h3>This Lumusae Product Is NPIA-Certified.</h3>
    <p><strong>Customer Name: </strong> ${match["Name"]}</p>
    <p><strong>Certificate No:</strong> ${match["Certificate No."]}</p>
    <p><strong>Product: </strong> ${match["Product Name"]}</p>
    <p><strong>Artisan: </strong> ${match["Artisans"]}</p> 
    <p><strong>Certification Date:</strong> ${match["Sales Date"]}</p>
    </div>
    <div class="middle-info">
      <img src="https://cdn.shopify.com/s/files/1/0677/7598/7865/files/Gemini_Generated_Image_ptpduxptpduxptpd_cde7dfc4-3023-4d8c-99db-19ccdde5322b.png" alt="logonepal" width="175" height="175">
    </div>
     <div class="txt bottomtext">
       Your product was handcrafted using authentic Changra cashmere sourced from the high Himalayas and certified by the *Nepal Pashmina Industry Association (NPIA)*.
     </div>
     </div>
    </div>

   <button style="display:none" onclick="window.print()">Download</button>

  </div>
`;




});
}






// function printCertificate() {
//   const cert = document.querySelector(".certificate-box");

//   if (!cert) {
//     alert("Certificate not found");
//     return;
//   }

//   // Save original document state
//   const originalContent = document.body.innerHTML;

//   // Replace body with certificate only
//   document.body.innerHTML = `
//     <div class="print-certificate">
//       ${cert.outerHTML}
//     </div>
//   `;

//   window.print();

//   // Restore original content
//   document.body.innerHTML = originalContent;

//   // Make scripts work again (Shopify reload fix)
//   location.reload();
// }



// Popup function
 function openPopup() {
      document.getElementById("overlay").style.display = "block";
      $("body").addClass("over-follow-hidden");
  }

  function closePopup() {
      document.getElementById("overlay").style.display = "none";
      $("body").removeClass("over-follow-hidden");
  }



document.querySelectorAll('.product-loop-slider').forEach((element) => {

 new Splide(element, {
  type: "loop",
  autoWidth: true,
  arrows: false,
  pagination: false,
  focus: "center",
  gap: "0px",
}).mount(window.splide.Extensions);

});


// article page toggle
if (window.innerWidth <= 767) {
 const heading = document.querySelector(".tableContent h3");
  const list = document.getElementById("listCateID");

  // Hide by default
  if (list) {
    list.style.display = "none";
  }

  // Toggle on click
  if (heading && list) {
    heading.addEventListener("click", function () {

      if (list.style.display === "none") {
        list.style.display = "flex";
      } else {
        list.style.display = "none";
      }

    });
  }
}